<template>
  <div>
    <div class="flex justify-end" v-if="order">
      <el-button
        @click="changeOrderState(order, 'ready_to_submit')"
        v-if="order.status.name === 'ready_to_submit'"
        title="Force Process Order"
        >Force Process Order</el-button
      >
      <el-button
        @click="changeOrderState(order, 'ready_to_submit')"
        v-if="order.status.name === 'paused'"
        title="Unpause Order"
        >Resume Order</el-button
      >
      <el-button
        @click="changeOrderState(order, 'paused')"
        v-if="order.status.name === 'ready_to_submit'"
        title="Pause Order"
        >Temporarily Stop Order</el-button
      >
      <el-button
        @click="changeOrderState(order, 'ready_to_submit')"
        v-if="order.status.name === 'submission_error'"
        title="Re-process Order"
        >Re-submit Order</el-button
      >
      <el-popconfirm
        v-if="
          order.status.name === 'ready_to_submit' ||
          order.status.name === 'paused' ||
          order.status.name === 'submission_error'
        "
        confirmButtonText="OK"
        cancelButtonText="No, Thanks"
        icon="el-icon-info"
        iconColor="red"
        title="This action is irreversible. Are you sure you want to proceed?"
        @confirm="changeOrderState(order, 'deleted')"
      >
        <template #reference>
          <el-button type="danger" title="Permanently Stop Order">Stop Order Permanently</el-button>
        </template>
      </el-popconfirm>
    </div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="Order Details" name="1">
        <div class="pl-4" v-if="order">
          <div class="order-detail-row pl-2">
            <label class="font-bold mr-2">ID: </label><span>{{ order.id }}</span>
          </div>
          <div class="order-detail-row pl-2">
            <label class="font-bold mr-2">Order Refernce: </label><span>{{ order.orderRef }}</span>
          </div>
          <div class="order-detail-row pl-2">
            <label class="font-bold mr-2">Created date: </label><span>{{ createdDate }}</span>
          </div>
          <div class="order-detail-row pl-2">
            <label class="font-bold mr-2">Address From: </label><span>{{ order.addressFrom }}</span>
          </div>
          <div class="order-detail-row pl-2">
            <label class="font-bold mr-2">Address To: </label><span> {{ order.addressTo }}</span>
          </div>
          <div class="order-detail-row pl-2">
            <label class="font-bold mr-2">Shipping Carrier: </label>
            <span>{{ order.shippingCarrier }} </span>
          </div>
          <div class="order-detail-row pl-2">
            <label class="font-bold mr-2">Shipping Priority: </label> <span>{{ order.shippingPriority }} </span>
          </div>
          <div class="order-detail-row pl-2">
            <label class="font-bold mr-2">Status: </label><span class="capitalize">{{ order.statusFormatted }}</span>
          </div>
          <div class="order-detail-row pl-2">
            <label class="font-bold mr-2">Reprint: </label><span class="capitalize">{{ order.reprint }}</span>
          </div>
          <div class="order-detail-row pl-2">
            <label class="font-bold mr-2">XQC: </label><span class="capitalize">{{ order.xqc }}</span>
          </div>
          <div class="order-detail-row pl-2 submission-log" v-if="order.order_submission_log">
            <label class="font-bold mr-2">Order Submission Log: </label>
            <div class="capitalize">
              <pre>{{ order.order_submission_log.response_log }}</pre>
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item title="Order Line Items" name="2">
        <el-table v-loading="isLoading" @row-click="openSidebar" :data="lineItems" style="width: 100%">
          <el-table-column prop="sku" label="SKU"> </el-table-column>
          <el-table-column prop="ref" label="REF"> </el-table-column>
          <el-table-column prop="quantity" label="Quantity" width="100"> </el-table-column>
          <el-table-column prop="status" label="Status" width="120"> </el-table-column>
        </el-table>
      </el-collapse-item>
    </el-collapse>
  </div>
  <div @click="showCompleteJson = true" class="flex justify-end underline text-sm cursor-pointer mt-6">
    View Complete JSON
  </div>
  <el-dialog title="Complete JSON of order" v-model="showCompleteJson">
    <div>
      <pre>{{ order }}</pre>
    </div>
  </el-dialog>
  <el-drawer title="Item detail" v-model="showSidebar" :with-header="false">
    <item-detail :item="selectedItem"></item-detail>
  </el-drawer>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import ItemDetail from '../../components/item-detail.vue';
import { OrderClientModel } from '../../models/client';
import { OrderLineClientModel } from '../../models/client/order-line.client.model';
import { orderService } from '../../services';
import { formatDate } from '../../utils/date-formater';
import { ElNotification } from 'element-plus';

export default defineComponent({
  components: {
    ItemDetail,
  },
  data: function () {
    return {
      isUpdatingOrder: false,
      isLoading: false,
      showCompleteJson: false,
      showSidebar: false,
      activeNames: ['2'],
      order: null as OrderClientModel | null,
      lineItems: [] as OrderLineClientModel[],
      selectedItem: null,
    };
  },
  created() {
    this.getOrder(this.$route.params.id);
  },
  methods: {
    async getOrder(id) {
      try {
        this.order = await orderService.getOrderById(id);
        this.lineItems = this.order.lineItems;
      } catch (e) {
        ElNotification({
          title: 'Error',
          type: 'error',
          message: 'Failed to load requested data. Please try again later.',
          position: 'bottom-right',
        });
      }
      this.isLoading = false;
    },
    openSidebar(item): void {
      this.selectedItem = item;
      this.showSidebar = true;
    },
    async changeOrderState(order: OrderClientModel, state) {
      this.isUpdatingOrder = true;
      const response = await orderService.updateOrderQueueStatus(
        order.orderRef,
        state !== order.status.name ? state : ''
      );
      const orderObj = new OrderClientModel(response.order);
      Object.assign(this.order, orderObj);
      this.isUpdatingOrder = false;
    },
  },
  computed: {
    createdDate(): string | undefined {
      if (this.order) {
        return formatDate(this.order.dateCreated);
      }
      return '';
    },
  },
});
</script>

<style lang="scss" scoped>
::v-deep(.el-collapse) {
  border-top: none;
}

::v-deep(tr) {
  cursor: pointer;
}

::v-deep(.el-collapse-item:last-child .el-collapse-item__wrap) {
  border-bottom: none;
}

.order-detail-row:hover {
  background-color: #f5f7fa;
}

.submission-log {
  display: flex;
}

.submission-log label {
  white-space: nowrap;
}

pre {
  white-space: pre-wrap;
}
</style>
